export type HorizontalCenter = "none" | "left" | "middle" | "right";